import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M0 1C0 0.447715 0.447715 0 1 0H14C14.2652 0 14.5196 0.105357 14.7071 0.292893L19.7071 5.29289C19.8946 5.48043 20 5.73478 20 6V10.252C19.3608 10.0875 18.6906 10 18 10C14.6426 10 11.7683 12.0682 10.5815 15H5V11.8223L7.69055 9.20462L9.39299 10.9071C9.78351 11.2976 10.4167 11.2976 10.8072 10.9071L14.0072 7.70711L12.5929 6.29289L10.1001 8.78574L8.4073 7.09294C8.02056 6.7062 7.39487 6.70191 7.00286 7.0833L5 9.03192V4H3V16C3 16.5523 3.44771 17 4 17H10.0619C10.021 17.3276 10 17.6613 10 18C10 19.4571 10.3896 20.8233 11.0703 22H1C0.447715 22 0 21.5523 0 21V1Z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M24 18C24 21.3137 21.3137 24 18 24C14.6863 24 12 21.3137 12 18C12 14.6863 14.6863 12 18 12C21.3137 12 24 14.6863 24 18ZM17 14V18C17 18.5523 17.4477 19 18 19H21V17H19V14H17Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }